export class imgGallery{
   path:string;
   id:string;
   position:number;
}